import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateShouldAutoShowDataOrientationPaneParams {
  user: string;
  shouldShowPane: boolean;
}

export class UpdateShouldAutoShowDataOrientationPaneRequest extends Request<IUpdateShouldAutoShowDataOrientationPaneParams, IResult> {
  constructor(params: IUpdateShouldAutoShowDataOrientationPaneParams) {
    super('updateShouldAutoShowDataOrientationPane', params);
  }
}
